// src/components/HeroImagesManager.jsx
import React, { useState, useEffect } from "react";
import { db } from "../firebase-config";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
} from "firebase/firestore";

import GoogleDriveImage from "./GoogleDriveImage";

function HeroImagesManager() {
  const [items, setItems] = useState([]);
  const [heroBg, setHeroBg] = useState("");

  const [imageSource, setImageSource] = useState("cloudinary");
  const [bgSource, setBgSource] = useState("cloudinary");

  const [imageUrl, setImageUrl] = useState("");
  const [bgUrl, setBgUrl] = useState("");

  useEffect(() => {
    fetchItems();
    fetchHeroBg();
  }, []);

  // Fetch all hero images
  const fetchItems = async () => {
    const snapshot = await getDocs(collection(db, "hero_images"));
    const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
    setItems(data);
  };

  // Fetch hero background
  const fetchHeroBg = async () => {
    const bgDoc = await getDoc(doc(db, "hero-background", "main"));
    if (bgDoc.exists()) {
      setHeroBg(bgDoc.data().url);
    } else {
      setHeroBg("");
    }
  };

  /* ---------------- HERO IMAGE UPLOAD ---------------- */
  const handleUpload = () => {
    // Google Drive
    if (imageSource === "url") {
      if (!imageUrl) {
        alert("Please provide Google Drive image");
        return;
      }
      saveHeroImage(imageUrl);
      return;
    }

    // Cloudinary
    const widget = window.cloudinary.createUploadWidget(
      {
        cloudName: "dgxhp09em",
        uploadPreset: "unsigned_preset",
      },
      (error, result) => {
        if (!error && result?.event === "success") {
          saveHeroImage(result.info.secure_url);
        }
      }
    );

    widget.open();
  };

  const saveHeroImage = async (finalUrl) => {
    await addDoc(collection(db, "hero_images"), {
      imageUrl: finalUrl,
    });
    alert("✅ Image added!");
    setImageUrl("");
    fetchItems();
  };

  /* ---------------- HERO BACKGROUND ---------------- */
  const handleBgUpload = () => {
    // Google Drive
    if (bgSource === "url") {
      if (!bgUrl) {
        alert("Please provide Google Drive background image");
        return;
      }
      saveHeroBg(bgUrl);
      return;
    }

    // Cloudinary
    const widget = window.cloudinary.createUploadWidget(
      {
        cloudName: "dgxhp09em",
        uploadPreset: "unsigned_preset",
        multiple: false,
      },
      (error, result) => {
        if (!error && result?.event === "success") {
          saveHeroBg(result.info.secure_url);
        }
      }
    );

    widget.open();
  };

  const saveHeroBg = async (finalUrl) => {
    await setDoc(doc(db, "hero-background", "main"), {
      url: finalUrl,
    });
    alert("✅ Hero background updated!");
    setBgUrl("");
    setHeroBg(finalUrl);
  };

  /* ---------------- DELETE ---------------- */
  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "hero_images", id));
    fetchItems();
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Hero Images Manager</h3>

      <select
        className="form-select mb-2"
        value={imageSource}
        onChange={(e) => setImageSource(e.target.value)}
      >
        <option value="cloudinary">Upload via Cloudinary</option>
        <option value="url">Use Google Drive Image</option>
      </select>

      {imageSource === "url" && (
        <GoogleDriveImage onImageReady={(url) => setImageUrl(url)} />
      )}

      <button className="btn btn-success mb-4" onClick={handleUpload}>
        Add Hero Image
      </button>

      <div className="row">
        {items.map((item) => (
          <div key={item.id} className="col-md-4 mb-3">
            <div className="card">
              <img
                src={item.imageUrl}
                className="card-img-top"
                alt="Hero"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/400x300?text=Image+Unavailable";
                }}
              />
              <div className="card-body">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(item.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <hr className="my-4" />

      <h4 className="mb-3">Hero Background Manager</h4>

      <select
        className="form-select mb-2"
        value={bgSource}
        onChange={(e) => setBgSource(e.target.value)}
      >
        <option value="cloudinary">Upload via Cloudinary</option>
        <option value="url">Use Google Drive Image</option>
      </select>

      {bgSource === "url" && (
        <GoogleDriveImage onImageReady={(url) => setBgUrl(url)} />
      )}

      <button className="btn btn-primary mb-3" onClick={handleBgUpload}>
        Change Hero Background
      </button>

      {heroBg && (
        <img
          src={heroBg}
          alt="Hero Background"
          style={{
            maxWidth: 480,
            borderRadius: 12,
            boxShadow: "0 2px 12px #0d6efd22",
          }}
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/600x300?text=Background+Unavailable";
          }}
        />
      )}
    </div>
  );
}

export default HeroImagesManager;
